<template>
  <div class="payment-detail">
    <div class="payment-detail-top">
      <div class="top-title">
        <span>订单详情</span>
        <div class=""></div>
      </div>
      <div class="order-desc">
        <div class="top-title order-title">
          订单编号：{{ info?.code || "-" }}
        </div>
        <el-descriptions
          :column="4"
          :colon="false"
          :labelStyle="{
            fontSize: '14px',
            fontWeight: '500',
            color: '#86909C',
            width: '70px',
          }"
          :contentStyle="{
            fontSize: '14px',
            fontWeight: '400',
            color: '#1D2129',
          }"
        >
          <el-descriptions-item label="订单类型">
            {{ "订阅订单" }}
          </el-descriptions-item>
          <el-descriptions-item label="平台订单ID">
            {{ info.transactionId }}
          </el-descriptions-item>
          <el-descriptions-item label="用户">
            <span
              style="cursor: pointer; color: #165dff"
              @click="toUserDetail(info?.userId)"
            >
              {{ info?.un || "-" }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            {{ statusMap[info.status] || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="支付通道">{{
            paymentChannelMap[info.paymentChannel] || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="会员内容">{{
            contentMap[info.subscribeType] || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="提交时间">
            {{ info?.createdAt || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="订单金额">{{
            info?.amount || "-"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="payment-detail-top payment-detail-info">
      <div class="">
        <span class="top-title">订阅信息</span>
        <div class="table-space">
          <div class="table-title">
            <div class="table-title-item">订阅扣款周期</div>
            <div class="table-title-item">扣款金额</div>
            <div class="table-title-item">币种</div>
            <div class="table-title-item">首次扣款时间</div>
          </div>
          <div class="table-content">
            <div class="table-content-item">
              {{ deductionMap[info.subscribeType] || "-" }}
            </div>
            <div class="table-content-item">
              {{ info?.deductionAmount || "-" }}
            </div>
            <div class="table-content-item">{{ info?.currency || "-" }}</div>
            <div class="table-content-item">
              {{ info?.firstDeductionTime || "-" }}
            </div>
          </div>
        </div>
        <span class="top-title" style="margin-top: 20px">体验会员</span>
        <div class="table-space">
          <div class="table-title">
            <div class="table-title-item">是否赠送体验</div>
            <div class="table-title-item">体验内容</div>
            <div class="table-title-item">开始时间</div>
            <div class="table-title-item">结束时间</div>
          </div>
          <div class="table-content">
            <div class="table-content-item">
              {{ info?.subscribeFirst === 1 ? "是" : "否" || "-" }}
            </div>
            <div class="table-content-item">
              {{ info?.subscribeFirst === 1 ? "2周体验VIP" : "-" }}
            </div>
            <div class="table-content-item">
              {{ info?.freeStartTime || "-" }}
            </div>
            <div class="table-content-item">{{ info?.freeEndTime || "-" }}</div>
          </div>
        </div>
        <span class="top-title" style="margin-top: 20px">退订信息</span>
        <div class="table-space">
          <div class="table-title">
            <div class="table-title-item" style="width: 50%">退订方式</div>
            <div class="table-title-item">退订时间</div>
          </div>
          <div class="table-content">
            <div class="table-content-item" style="width: 50%">
              {{ unsubscribeMethodMap[info.unsubscribeMethod] || "-" }}
            </div>
            <div class="table-content-item">
              {{ info?.unsubscribeTime || "-" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      info: {},
      vipAll: {},
      statusMap: {
        1: "订阅成功",
        2: "取消订阅",
      },
      paymentChannelMap: {
        1: "iOS",
        2: "android",
        3: "微信",
      },
      contentMap: {
        1: "VIP年会员",
        2: "VIP半年会员",
        3: "VIP月会员",
      },
      unsubscribeMethodMap: {
        1: "后台",
        2: "退款",
        3: "退订",
        4: "到期",
      },
      deductionMap: {
        1: "年扣款",
        2: "半年扣款",
        3: "月扣款",
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    const vipAll = localStorage.getItem("VIP_ALL");
    if (vipAll) {
      this.vipAll = JSON.parse(vipAll);
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$get(`/vip/subscribe/details`, {
        id: this.id,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.info = res.data?.data || {};
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toUserDetail(uid) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: uid,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.payment-detail {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.payment-detail-top {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.top-title {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
}
.refund {
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px 2px;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.order-desc {
  margin-top: 20px;
}
.order-title {
  margin-bottom: 16px;
}
.payment-detail-info {
  margin-top: 20px;
  // height: 100%;
}
.table-space {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  border: 1px solid #e5e6eb;
}
.table-title {
  display: flex;
  width: 100%;
  background-color: #f2f3f5;
  padding: 7px 16px;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 14px;
  color: #1d2129;
  border-bottom: 1px solid #e5e6eb;
}
.table-title-item {
  display: flex;
  width: 25%;
}
.table-content {
  display: flex;
  width: 100%;
  padding: 14px 16px;
  box-sizing: border-box;
}
.table-content-item {
  display: flex;
  width: 25%;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
</style>
